module.exports = __webpack_public_path__ + "static/img/007.b8f2837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/datav-gejiachecun/007.png
// module id = QMbw
// module chunks = 1